import { IconStatus, Tooltip, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { BasketOrderStatusEntity } from '@genial/services';
import { Text, ITextProps } from 'native-base';
import React from 'react';

import { messageError } from '../../store/batchTicket/constants';
import { getValidatedStatusIcon } from '../../utils/getValidatedStatusIcon';

interface TableContentItemStatusProps extends ITextProps {
  basketAdvisorStatus?: BasketOrderStatusEntity;
  customTooltipLabel?: string;
}

export const TableContentItemStatus: React.FC<TableContentItemStatusProps> = ({
  basketAdvisorStatus,
  customTooltipLabel,
  variant = 'regular',
  ...rest
}) => {
  if (!basketAdvisorStatus) {
    return <></>;
  }

  const statusIcon = getValidatedStatusIcon(basketAdvisorStatus.statusIcon);

  return (
    <Tooltip
      label={customTooltipLabel || basketAdvisorStatus?.statusAlias || messageError}
      testID="item-status-tooltip">
      <HStack space={Spacing['inline.quarck']} alignItems="center">
        <IconStatus
          testId="icon-status"
          bgColor={statusIcon.backgroundColor}
          icon={statusIcon.icon}
          color={statusIcon.iconColor}
          size={statusIcon.iconSize}
        />
        <Text
          color="neutral.darkest"
          variant={variant}
          fontSize={Typography['fontsize.md']}
          noOfLines={1}
          {...rest}>
          {basketAdvisorStatus?.statusAlias || messageError}
        </Text>
      </HStack>
    </Tooltip>
  );
};
